const INITIAL_STATE = {
  list: [],
  loginStep: 0,
  loading: false,
  message: null,
  sidebarShow: "responsive"
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, { type, payload, ...rest }) => {
  switch (type) {
    // all Category
    case "fetch_category_start":
      return { ...state, loading: true, message: "" };
    case "fetch_category_error":
      return { ...state, message: payload, loading: false };
    case "fetch_category_success":
      return {
        ...state,
        message: payload.message,
        loading: false,
        list: payload.data
      };

    /* other */
    default:
      return state;
  }
};
